import EcoImg from 'eco-design/base/eco-img';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';
import css from './index.module.scss';
import { useLang } from '@/i18n';

export default function Screen6() {
    const { t } = useLang('theProductV2.Screen6');
    const webpOrJpg = useWebpOrJpg('#rapid-mag-Screen6-V2');

    return (
        <section
            className={`${css.comp} temp-rapid-mag-Screen6-V2  GtmModuleData-section`}
            id="rapid-mag-Screen6-V2"
            data-section-id={'rapid-mag-Screen6-V2'}
            data-section-title={t('title')}
        >
            <div className="label">{t('label')}</div>
            <div className="title">{t('title')}</div>
            <div className="desc">{t('desc')}</div>
            <div className="img-box">
                <EcoImg
                    pc={webpOrJpg(
                        'https://websiteoss.ecoflow.com/upload/image/1761547736986/Screen6.jpg',
                        'https://websiteoss.ecoflow.com/upload/image/1761547754118/Screen6.webp',
                    )}
                    h5={webpOrJpg(
                        'https://websiteoss.ecoflow.com/upload/image/1761547736857/Screen6-m.jpg',
                        'https://websiteoss.ecoflow.com/upload/image/1761547753983/Screen6-m.webp',
                    )}
                />
            </div>
        </section>
    );
}
